import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";

const TabListContent = ["Digital Art"];

const AllPortfolioItem = [
  {
    img: "da-1",
    title: "",
    meta: "",
    dalayAnimation: "",
  },
  {
    img: "da-2",
    title: "",
    meta: "",
    dalayAnimation: "100",
  },
  {
    img: "da-3",
    title: "",
    meta: "",
    dalayAnimation: "200",
  },
  {
    img: "da-4",
    title: "",
    meta: "",
    dalayAnimation: "0",
  },
  {
    img: "da-5",
    title: "",
    meta: "",
    dalayAnimation: "100",
  },
  {
    img: "da-6",
    title: "",
    meta: "",
    dalayAnimation: "200",
  },
  {
    img: "da-7",
    title: "",
    meta: "",
    dalayAnimation: "200",
  },  
];

const PortfolioDigital = () => {
  return (
    <SimpleReactLightbox>
      <Tabs className="portfolio-container">
        <div className="controls po-control-one text-center mb-90 md-mb-50 mt-90 md-mt-60">
          <TabList className="d-flex flex-wrap justify-content-center">
            {TabListContent.map((tab, i) => (
              <Tab key={i}>
                <button type="button" className="control">
                  {tab}
                </button>
              </Tab>
            ))}
          </TabList>
        </div>
        {/* End pc-control-one */}
        <SRLWrapper>
          <TabPanel>
            <div className="mixitUp-container  gutter-space-one d-flex flex-wrap">
              {AllPortfolioItem.map((item, i) => (
                <div
                  className="mix"
                  key={i}
                  data-aos="fade-right"
                  data-aos-delay={item.dalayAnimation}
                >
                  <div className="portfolio-block-two position-relative">
                    <div className="d-flex align-items-center justify-content-center">
                      <img
                        src={`images/site/programmes/${item.img}.webp`}
                        alt={item.meta}
                        className="w-100 h-100 tran4s img-meta"
                      />
                      <div className="fancybox">
                        <i className="fa fa-arrows-alt" aria-hidden="true"></i>
                      </div>
                    </div>
                    {/* /.hover-content */}
                  </div>
                  {/* /.portfolio-block-two */}
                </div>
              ))}
            </div>
            {/* single mixitUp-container */}
          </TabPanel>
        </SRLWrapper>
      </Tabs>
    </SimpleReactLightbox>
  );
};

export default PortfolioDigital;
